import { lerp } from './math';
import type { Actor, Theme } from './types';

export interface Arrival {
  message: string;
  /** Fraction of the safe horizontal span, resolved against current page geometry. */
  position: number;
}

/** Pick once per instance; scrolling, resizing and reset never reroll the arrival. */
export function pickArrival(
  theme: Pick<Theme, 'greetings'>,
  random: () => number = Math.random,
): Arrival {
  return {
    message: theme.greetings[Math.floor(random() * theme.greetings.length)]!,
    position: random(),
  };
}

export function placeArrival(
  position: number,
  width: number,
  size: number,
): Pick<Actor, 'x' | 'facing'> {
  // Room for both themes' standing silhouettes, plus a little space from the edge.
  // A container narrower than the sprite leaves it centered rather than off to one side.
  const margin = Math.min(width / 2, size * 0.6 + 12);
  return {
    x: lerp(margin, width - margin, position),
    facing: position < 0.5 ? 1 : -1,
  };
}
